(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bojuna-build-box"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bojuna-box')){customElements.define('bojuna-box',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.choices=new Map();this.tabs=[...this.querySelectorAll('[data-step]')];this.addEventListener('click',e=>{if(this.busy)return;const checkout=e.target.closest('.bb-checkout');if(checkout&&!checkout.disabled){this.addBox();return;}const tab=e.target.closest('[data-step]');const change=e.target.closest('[data-change]');const next=e.target.closest('[data-next]');const select=e.target.closest('.bb-select');if(tab)this.show(Number(tab.dataset.step));if(change)this.show(Number(change.dataset.change),true);if(next)this.show(Number(next.dataset.next),true);if(select&&!select.disabled){const card=select.closest('[data-variant]');this.choices.set(Number(card.dataset.group),card);this.update();}});this.querySelector('.bb-tabs').addEventListener('keydown',e=>{if(this.busy)return;if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const n=this.tabs.indexOf(document.activeElement);const i=e.key==='Home'?0:e.key==='End'?3:(n+(e.key==='ArrowRight'?1:3))%4;this.show(i);this.tabs[i].focus();});}
show(i,scroll=false){this.tabs.forEach((b,n)=>{b.setAttribute('aria-selected',String(n===i));b.tabIndex=n===i?0:-1;});this.querySelectorAll('[data-panel]').forEach(p=>p.hidden=Number(p.dataset.panel)!==i);if(scroll)this.querySelector('.bb-tabs').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}
update(){this.querySelectorAll('[data-variant]').forEach(card=>{const yes=this.choices.get(Number(card.dataset.group))===card;card.dataset.selected=String(yes);const b=card.querySelector('.bb-select');b.setAttribute('aria-pressed',String(yes));if(!b.disabled)b.textContent=yes?this.dataset.chosen:this.dataset.choose;});this.choices.forEach((card,i)=>{const slot=this.querySelector('[data-slot="'+i+'"]');slot.dataset.filled='true';slot.querySelector('.bb-selected-name').textContent=card.dataset.name;const thumb=slot.querySelector('.bb-thumb');thumb.replaceChildren();const img=card.querySelector('img');if(img){const copy=img.cloneNode();copy.alt='';thumb.append(copy);}slot.querySelector('button').textContent=this.dataset.changeLabel;slot.querySelector('button').setAttribute('aria-label',this.dataset.changeLabel+': '+card.dataset.name);});this.tabs.forEach((tab,i)=>tab.dataset.complete=String(this.choices.has(i)));this.querySelector('.bb-box-count').textContent=this.choices.size+' / 4';this.querySelector('.bb-progress').textContent=this.dataset.progress.replace('[count]',this.choices.size);this.querySelector('.bb-progress-track span').style.width=(this.choices.size*25)+'%';const checkout=this.querySelector('.bb-checkout');checkout.disabled=this.busy||this.choices.size!==4;checkout.textContent=this.busy?this.dataset.addingLabel:this.choices.size===4?this.dataset.addLabel:this.dataset.incompleteLabel;this.querySelector('.bb-error').hidden=true;}
async addBox(){
if(this.busy||this.choices.size!==4)return;
this.busy=true;this.update();
const selected=[0,1,2,3].map(i=>this.choices.get(i)),error=this.querySelector('.bb-error');
try{
if(!this.bundleMap){const mappingResponse=await fetch(this.dataset.mapUrl);if(!mappingResponse.ok)throw new Error(this.dataset.errorLabel);this.bundleMap=await mappingResponse.json();}
const indices=selected.map((card,i)=>this.bundleMap.groups[i].indexOf(card.dataset.variant));
if(indices.some(i=>i<0))throw new Error(this.dataset.errorLabel);
const sizes=this.bundleMap.groups.map(g=>g.length),index=((indices[0]*sizes[1]+indices[1])*sizes[2]+indices[2])*sizes[3]+indices[3],variant=this.bundleMap.variants[index];
if(!variant||this.bundleMap.price!==2000)throw new Error(this.dataset.errorLabel);
const root=window.Shopify&&window.Shopify.routes?window.Shopify.routes.root:'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant,quantity:1}]})});
const result=await response.json();
if(!response.ok)throw new Error(result.description||result.message||this.dataset.errorLabel);
window.location.assign(root+'cart');
}catch(e){this.busy=false;this.update();error.textContent=e.message||this.dataset.errorLabel;error.hidden=false;}
}

});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bojuna-men"] && !Shopify.designMode) return;
  try {
    
function initBojunaMen(scope=document){
  scope.querySelectorAll('[data-bojuna-men]').forEach(root=>{
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const cards=[...root.querySelectorAll('[data-men-card]')];
    const buttons=[...root.querySelectorAll('[data-men-filter]')];
    const count=root.querySelector('[data-men-count]');
    const search=root.querySelector('[data-men-search]');
    let category='edit';
    function render(){
      let visible=0;
      const query=search.value.trim().toLocaleLowerCase();
      cards.forEach(card=>{const group=category==='edit'?(!query?card.dataset.edit==='true':true):card.dataset.category===category;const show=group&&card.dataset.name.toLocaleLowerCase().includes(query);card.hidden=!show;if(show)visible++;});
      buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.menFilter===category)));
      count.textContent=count.dataset.countTemplate.replace('__COUNT__',String(visible));
      root.querySelector('[data-men-empty]').hidden=visible!==0;
    }
    buttons.forEach(button=>button.addEventListener('click',()=>{category=button.dataset.menFilter;render();}));
    root.querySelectorAll('[data-men-jump]').forEach(link=>link.addEventListener('click',()=>{category=link.dataset.menJump;search.value='';render();}));
    root.querySelectorAll('[data-men-mobile-jump]').forEach(link=>link.addEventListener('click',event=>{
      if(!window.matchMedia('(max-width:749px)').matches)return;
      event.preventDefault();
      category=link.dataset.menMobileJump;
      search.value='';
      render();
      const shop=root.querySelector('.bm-shop');
      shop.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});
      history.replaceState(null,'','#'+shop.id);
    }));
    search.addEventListener('input',render);
    root.querySelector('[data-men-clear]').addEventListener('click',()=>{search.value='';render();search.focus();});
    render();
  });
}
initBojunaMen();
document.addEventListener('shopify:section:load',event=>initBojunaMen(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bojuna-october-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const startsAt = Date.parse('2026-11-01T00:00:00+00:00');
    const expiresAt = Date.parse('2027-01-01T00:00:00Z');
    function closeDetails(root) {
      const button = root.querySelector('.bojuna-details-toggle');
      const details = root.querySelector('.bojuna-delivery-details');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
        button.textContent = button.dataset.detailsLabel;
      }
      if (details) details.hidden = true;
    }
    function syncOffer() {
      const active = Date.now() >= startsAt && Date.now() < expiresAt;
      document.querySelectorAll('[data-bojuna-october]').forEach(root => {
        const row = root.querySelector('[data-bojuna-october-offer]');
        if (row) row.hidden = !active;
        if (!active) closeDetails(root);
      });
    }
    function initialise() {
      document.querySelectorAll('[data-bojuna-october]').forEach(root => {
        const button = root.querySelector('.bojuna-details-toggle');
        const details = root.querySelector('.bojuna-delivery-details');
        if (!button || !details || button.dataset.ready === 'true') return;
        button.addEventListener('click', () => {
          if (Date.now() >= expiresAt) { syncOffer(); return; }
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          details.hidden = expanded;
          button.textContent = expanded ? button.dataset.detailsLabel : button.dataset.closeLabel;
        });
        root.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !details.hidden) { closeDetails(root); button.focus(); }
        });
        button.dataset.ready = 'true';
      });
      syncOffer();
    }
    function scheduleExpiry() {
      syncOffer();
      const remaining = expiresAt - Date.now();
      if (remaining > 0) setTimeout(scheduleExpiry, Math.min(remaining, 2147483000));
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
    else initialise();
    document.addEventListener('shopify:section:load', initialise);
    document.addEventListener('visibilitychange', syncOffer);
    window.addEventListener('pageshow', syncOffer);
    scheduleExpiry();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bojuna-refined-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bojuna-refined-footer')) {
    customElements.define('bojuna-refined-footer', class extends HTMLElement {
      connectedCallback() {
        this.groups = Array.from(this.querySelectorAll('.bojuna-footer__group'));
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.mobileStates = this.groups.map(group => group.dataset.mobileOpen === 'true');
        this.handleClick = event => {
          if (!this.mobile.matches && event.target.closest('summary')) event.preventDefault();
        };
        this.handleToggle = event => {
          if (this.mobile.matches) this.mobileStates[this.groups.indexOf(event.target)] = event.target.open;
        };
        this.updateLayout = () => {
          this.groups.forEach((group, index) => {
            group.open = this.mobile.matches ? this.mobileStates[index] : true;
            group.querySelector('summary').tabIndex = this.mobile.matches ? 0 : -1;
          });
        };
        this.addEventListener('click', this.handleClick);
        this.groups.forEach(group => group.addEventListener('toggle', this.handleToggle));
        this.mobile.addEventListener('change', this.updateLayout);
        this.updateLayout();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.groups.forEach(group => group.removeEventListener('toggle', this.handleToggle));
        this.mobile.removeEventListener('change', this.updateLayout);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
